import { METRIC_COLUMN_IDS, METRIC_COLUMN_TITLES } from "components/inputs/InputsOveriew/metricColumns";
const getInputsTableElements = () => {
  const tableLayout = {
    entityTableId: "inputs",
    defaultPageSize: 50,
    defaultSort: { attributeId: "title", direction: "asc" },
    defaultDisplayedAttributes: [
      "title",
      "type",
      "direction",
      "desired_state",
      "traffic",
      "input_failures",
      "node_id",
      "address",
      "port"
    ],
    defaultColumnOrder: [
      "title",
      "type",
      "direction",
      "desired_state",
      "traffic",
      "input_failures",
      METRIC_COLUMN_IDS.messagesPerStream,
      METRIC_COLUMN_IDS.extractorCount,
      METRIC_COLUMN_IDS.associatedStreams,
      "node_id",
      "address",
      "port"
    ]
  };
  const additionalAttributes = [
    { id: "traffic", title: "Traffic Last Minute" },
    { id: "input_failures", title: "Input Failures" },
    { id: "address", title: "Address" },
    { id: "port", title: "Port", type: "INT" },
    {
      id: METRIC_COLUMN_IDS.messagesPerStream,
      title: METRIC_COLUMN_TITLES[METRIC_COLUMN_IDS.messagesPerStream]
    },
    {
      id: METRIC_COLUMN_IDS.extractorCount,
      title: METRIC_COLUMN_TITLES[METRIC_COLUMN_IDS.extractorCount],
      type: "INT"
    },
    {
      id: METRIC_COLUMN_IDS.associatedStreams,
      title: METRIC_COLUMN_TITLES[METRIC_COLUMN_IDS.associatedStreams]
    }
  ];
  return {
    tableLayout,
    additionalAttributes
  };
};
export default getInputsTableElements;
